export const GOOGLE_ACCOUNT_SETTING = 'https://myaccount.google.com/';
